import React from "react";
import { cn } from "@/lib/utils";

export function Skeleton({ className }) {
  return (
    <div
      className={cn(
        "relative overflow-hidden rounded-md bg-secondary/50",
        "after:absolute after:inset-0 after:-translate-x-full after:animate-[shimmer_1.5s_infinite] after:bg-gradient-to-r after:from-transparent after:via-white/10 after:to-transparent",
        className
      )}
    />
  );
}

export function KpiSkeletonGrid({ count = 4 }) {
  return (
    <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className="glass rounded-2xl p-6">
          <Skeleton className="h-4 w-24" />
          <Skeleton className="mt-4 h-9 w-32" />
          <Skeleton className="mt-4 h-3 w-20" />
        </div>
      ))}
    </div>
  );
}

export function TableSkeleton({ rows = 6, cols = 5 }) {
  return (
    <div className="glass overflow-hidden rounded-2xl p-2">
      <div className="p-4">
        <Skeleton className="h-5 w-40" />
      </div>
      <div className="space-y-2 p-3">
        {Array.from({ length: rows }).map((_, r) => (
          <div key={r} className="flex items-center gap-4 rounded-lg p-3">
            {Array.from({ length: cols }).map((_, c) => (
              <Skeleton key={c} className={cn("h-4", c === 0 ? "w-40" : "w-24")} />
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}

export function ChartSkeleton({ className }) {
  return (
    <div className={cn("glass rounded-2xl p-6", className)}>
      <Skeleton className="h-5 w-36" />
      <Skeleton className="mt-6 h-[260px] w-full rounded-xl" />
    </div>
  );
}
